import { ListStarIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const SocialAdvertising = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <ListStarIcon size={Sizes[size]} {...rest} />;
};

SocialAdvertising.displayName = 'SocialAdvertising';
